import React, { useMemo, useState } from 'react';
import { motion, useMotionValue, useTransform } from 'framer-motion';
import ConsequenceReveal from '../shared/ConsequenceReveal';
import styles from './CuriosityExplorerEngine.module.css';

const LABELS = ['A', 'B', 'C', 'D', 'E'];

const CuriosityExplorerEngine = ({ gamifiedQuestion, onAnswer, accent = '#264653' }) => {
  const [value, setValue] = useState(3);
  const [showOutcome, setShowOutcome] = useState(false);
  const [locked, setLocked] = useState(false);
  const brightnessValue = useMotionValue(value);
  const brightness = useTransform(brightnessValue, [1, 5], [0.85, 1.12]);
  const selectedLabel = LABELS[value - 1];
  const selectedOption = useMemo(
    () => gamifiedQuestion?.options?.find((option) => option.label === selectedLabel),
    [gamifiedQuestion?.options, selectedLabel]
  );

  const submit = () => {
    if (locked) return;
    setLocked(true);
    setShowOutcome(true);
  };

  return (
    <div className={styles.engine} style={{ '--accent': accent }}>
      <motion.div className={styles.sceneCard} style={{ filter: useTransform(brightness, (b) => `brightness(${b})`) }}>
        <p className={styles.situation}>{gamifiedQuestion?.situation}</p>
        <div className={styles.chestArea}>
          <div className={styles.chestBase} />
          <motion.div
            className={styles.chestLid}
            animate={{ rotateX: value >= 4 ? -55 : value === 3 ? -28 : -8 }}
            transition={{ type: 'spring', stiffness: 120, damping: 18 }}
          />
          <motion.div
            className={styles.rays}
            animate={{ opacity: [0.1, value / 5, 0.1], scale: [0.9, 1.05, 0.9] }}
            transition={{ repeat: Infinity, duration: 1.4 }}
          />
        </div>

        <div className={styles.sliderBlock}>
          <input
            type="range"
            min={1}
            max={5}
            value={value}
            onChange={(event) => {
              const next = Number(event.target.value);
              setValue(next);
              brightnessValue.set(next);
            }}
          />
          <div className={styles.labels}>
            <span>Ignore</span>
            <span>Observe</span>
            <span>Try</span>
            <span>Adopt</span>
            <span>Explore Fully</span>
          </div>
          <button type="button" className={styles.confirm} onClick={submit}>
            Confirm Curiosity Response ({selectedLabel})
          </button>
        </div>
      </motion.div>

      <p className={styles.narration}>{gamifiedQuestion?.narration}</p>

      <ConsequenceReveal
        visible={showOutcome}
        tone={value >= 4 ? 'success' : value <= 2 ? 'danger' : 'warning'}
        message={selectedOption?.consequence || 'Curiosity response captured.'}
        duration={1700}
        onDone={() => {
          setShowOutcome(false);
          onAnswer(selectedLabel);
          setLocked(false);
        }}
      />
    </div>
  );
};

export default CuriosityExplorerEngine;
